<div class="container-fluid no-gutters d-block d-sm-none p-0">
  <div class="row">
    <button mat-icon-button (click)="mobileSidebarShow()" *ngIf="isShowSidebarMobile">
      <mat-icon>
        menu
      </mat-icon>
    </button>
    <button mat-icon-button (click)="mobileSidebarShow()" *ngIf="!isShowSidebarMobile">
      <mat-icon mat-list-icon>
        close
      </mat-icon>
    </button>
    <img src="../../../../../assets/images/ge-vernova-logo.svg" alt="" *ngIf="isShowSidebarMobile"
      class="img-right" style="cursor: pointer; padding-right: 35px;" onclick="location.href=''">
  </div>
  <div *ngIf="!isShowSidebarMobile">
    <!-- <div class="row no-gutters col-12 d-flex align-items-center justify-content-center text-normal">
      <button class="btn btn-primary button text-normal" style="border-radius: 20px;" (click)="contactUs()">Contact Us
      </button>
    </div> -->
    <ul class="list-unstyled row col-12 no-gutters justify-content-center pt-3">
      <li class="px-2">
        <a aria-label="Footter Links" href="https://www.facebook.com/gerenewableenergy" class="no-decoration">
          <i class="fa fa-facebook" aria-hidden="true"></i>
        </a>
      </li>
      <li class="px-2">
        <a aria-label="Footter Links" href="https://twitter.com/GErenewables" class="no-decoration">
          <i class="fa fa-twitter" aria-hidden="true"></i>
        </a>
      </li>
      <li class="px-2">
        <a aria-label="Footter Links" href="https://www.instagram.com/gerenewableenergy" class="no-decoration">
          <i class="fa fa-instagram" aria-hidden="true"></i>
        </a>
      </li>
      <li class="px-2">
        <a aria-label="Footter Links" href="https://www.linkedin.com/company/gerenewableenergy/" class="no-decoration">
          <i class="fa fa-linkedin-square" aria-hidden="true">
          </i>
        </a>
      </li>
    </ul>
    <div>
      <div class="col-12 px-0">
        <a href="/" class="text-left" style="color: black; text-transform: uppercase; font-weight: 700;">
          REN Supplier Portal
        </a>
        <hr>
      </div>
      <div *ngFor="let item of menuPortal; let i = index;">
        <div class="col-12 px-0">
          <a *ngIf="i!==3" [href]="userName ? item.url : redirectTo(item.redirectTo)" class="text-left"
            style="color: black; padding-left: 20px;">
            <strong>{{item.name}}</strong>
          </a>
          <!-- <a *ngIf="i===3" (click)="goPageWiki()" class="text-left"
            style="color: black; padding-left: 20px;">
            <strong>{{item.name}}</strong>
          </a> -->
        </div>
        <hr>
      </div>
    </div>
    <div *ngIf="userName && isSRM">
      <div class="col-12 px-0">
        <a href="/srm" class="text-left" style="color: black; text-transform: uppercase; font-weight: 700;">
          <strong>
            SRM
          </strong>
        </a>
      </div>
      <hr>
      <div *ngFor="let item of menuSRM">
        <div class="col-12 px-0">
          <a [routerLink]="item.url" class="text-left" style="color: black; padding-left: 20px;">
            <strong>
              {{item.name}}
            </strong>
          </a>
        </div>
        <hr>
      </div>
    </div>
    <div *ngIf="userName && isContract">
      <div class="col-12 px-0">
        <a href="/contracts" class="text-left" style="color: black; text-transform: uppercase; font-weight: 700;">
          <strong>
            Contract Management
          </strong>
        </a>
      </div>
      <hr>
      <div *ngFor="let item of menuContract">
        <div class="col-12 px-0">
          <a [routerLink]="item.url" class="text-left" style="color: black; padding-left: 20px;">
            <strong>
              {{item.name}}
            </strong>
          </a>
        </div>
        <hr>
      </div>
    </div>
    <div *ngIf="userName && isDocStore">
      <div class="col-12 px-0">
        <a href="/docstore" class="text-left" style="color: black; text-transform: uppercase; font-weight: 700;">
          <strong>
            Hydro DocStore
          </strong>
        </a>
      </div>
      <hr>
      <div *ngFor="let item of menuDocStore">
        <div class="col-12 px-0">
          <a [routerLink]="item.url" class="text-left" style="color: black; padding-left: 20px;">
            <strong>
              {{item.name}}
            </strong>
          </a>
        </div>
        <hr>
      </div>
    </div>
    <div *ngIf="userName && (isEOL || isSupplierHasPermission)">
      <div class="col-12 px-0">
        <a href="/eol" class="text-left" style="color: black; text-transform: uppercase; font-weight: 700;">
          <strong>
            EOL Forms
          </strong>
        </a>
      </div>
      <hr>
      <div *ngFor="let item of eolMenu" [hidden]="checkHidden(item.permissions, item)">
        <div class="col-12 px-0">
          <a [routerLink]="item.url" class="text-left" style="color: black; padding-left: 20px;">
            <strong>
              {{item.name}}
            </strong>
          </a>
        </div>
        <hr>
      </div>
    </div>
    <div *ngIf="userName">
      <div class="col-12 px-0 font-weight-bold">
        {{userName}}
      </div>
      <hr>
      <div class="col-12 px-0" >
        <a (click)="logOut()" class="text-left font-weight-bold">Sign Out</a>
      </div>
    </div>
    <div *ngIf="!userName">
      <div class="col-12 px-0" >
        <a href="/login" class="text-left font-weight-bold">Sign In</a>
      </div>
      <hr>
      <div class="col-12 px-0" >
        <a href="/login?srm=true" class="text-left font-weight-bold">Sign In To SRM</a>
      </div>
      <div class="col-12 px-0" >
        <a href="/login?contracts=true" class="text-left font-weight-bold">Sign In To Contract</a>
      </div>
      <div class="col-12 px-0" >
        <a href="/login?docstore=true" class="text-left font-weight-bold">Sign In To DocStore</a>
      </div>
      <hr>
    </div>
  </div>
</div>